import type { SelectedHomeyStoreState } from './SelectedHomeyStore';

export type SelectedHomeyStateSelection = Pick<
  SelectedHomeyStoreState,
  | 'selectedHomey'
  | 'baseUrl'
  | 'api'
  | 'loading'
  | 'error'
  | 'isConnected'
  | 'isRebooting'
  | 'isUpdating'
  | 'bootId'
  | 'connectionStatus'
  | 'reconnectAttempt'
  | 'connectionEpoch'
  | 'disconnectStartedAt'
  | 'lastConnectedAt'
  | 'lastRecoveredAt'
  | 'lastDisconnectDurationMs'
  | 'strategyId'
  | 'transportType'
>;

export type SelectedHomeyConnectionSelection = Pick<
  SelectedHomeyStoreState,
  | 'baseUrl'
  | 'connectionStatus'
  | 'disconnectStartedAt'
  | 'isConnected'
  | 'lastConnectedAt'
  | 'lastDisconnectDurationMs'
  | 'lastRecoveredAt'
  | 'reconnectAttempt'
  | 'connectionEpoch'
  | 'strategyId'
  | 'transportType'
>;

export type SelectedHomeyApiSelection = Pick<SelectedHomeyStoreState, 'api' | 'scopes'>;

export function selectSelectedHomeyState(
  state: SelectedHomeyStoreState,
): SelectedHomeyStateSelection {
  return {
    selectedHomey: state.selectedHomey,
    baseUrl: state.baseUrl,
    api: state.api,
    loading: state.loading,
    error: state.error,
    isConnected: state.isConnected,
    isRebooting: state.isRebooting,
    isUpdating: state.isUpdating,
    bootId: state.bootId,
    connectionStatus: state.connectionStatus,
    reconnectAttempt: state.reconnectAttempt,
    connectionEpoch: state.connectionEpoch,
    disconnectStartedAt: state.disconnectStartedAt,
    lastConnectedAt: state.lastConnectedAt,
    lastRecoveredAt: state.lastRecoveredAt,
    lastDisconnectDurationMs: state.lastDisconnectDurationMs,
    strategyId: state.strategyId,
    transportType: state.transportType,
  };
}

export function selectApiAndScopes(state: SelectedHomeyStoreState): SelectedHomeyApiSelection {
  return { api: state.api, scopes: state.scopes };
}

export function selectBaseUrl(state: SelectedHomeyStoreState): string | null {
  return state.baseUrl;
}

export function selectSelectedHomey(
  state: SelectedHomeyStoreState,
): SelectedHomeyStoreState['selectedHomey'] {
  return state.selectedHomey;
}

export function selectLanguage(state: SelectedHomeyStoreState): string | null {
  return state.language;
}

export function selectConnectionState(
  state: SelectedHomeyStoreState,
): SelectedHomeyConnectionSelection {
  return {
    baseUrl: state.baseUrl,
    connectionStatus: state.connectionStatus,
    disconnectStartedAt: state.disconnectStartedAt,
    isConnected: state.isConnected,
    lastConnectedAt: state.lastConnectedAt,
    lastDisconnectDurationMs: state.lastDisconnectDurationMs,
    lastRecoveredAt: state.lastRecoveredAt,
    reconnectAttempt: state.reconnectAttempt,
    connectionEpoch: state.connectionEpoch,
    strategyId: state.strategyId,
    transportType: state.transportType,
  };
}
